var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCarteleraGac(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_2",
    "data-name": "Capa 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 35.59 34.58",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-c1 {\r\n        stroke-linecap: round;\r\n        stroke-linejoin: round;\r\n      }\r\n\r\n      .cls-c1, .cls-c2, .cls-c3 {\r\n        fill: none;\r\n        stroke: currentcolor;\r\n      }\r\n\r\n      .cls-c2, .cls-c3 {\r\n        stroke-miterlimit: 10;\r\n      }\r\n\r\n      .cls-c3 {\r\n        stroke-width: .5px;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_3",
    "data-name": "Capa 3"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-c2",
    cx: 12.96,
    cy: 7.57,
    rx: 6.14,
    ry: 7.07
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-c1",
    d: "M16.87,17.61h-7.82c-4.72,0-8.55,3.83-8.55,8.55v6.47c0,.8.65,1.45,1.45,1.45h22.21c.8,0,1.45-.65,1.45-1.45v-3.65"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-c1",
    x1: 19.84,
    y1: 27.1,
    x2: 19.84,
    y2: 34.08
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-c1",
    x1: 5.8,
    y1: 27.1,
    x2: 5.8,
    y2: 33.79
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-c2",
    cx: 27.1,
    cy: 17.32,
    r: 8
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-c3",
    d: "M28.28,21.67h-3.24v1.56c0,.33.27.61.61.61h2.03c.33,0,.61-.27.61-.61v-1.56h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-c3",
    d: "M25.57,15.46c.04.33.3.6.63.64.1.01.2,0,.3-.02.08-.02.17.04.17.13v1.28h-1.28c-.09,0-.15.08-.13.17.03.09.04.19.02.3-.04.33-.31.59-.64.63-.43.05-.8-.29-.8-.72,0-.07.01-.14.03-.2.02-.09-.04-.17-.13-.17h-.68c-.02-.14-.02-.29-.02-.44.01-1.9,1.51-3.47,3.38-3.59.13,0,.24.09.24.22v.89c0,.09-.09.15-.17.13-.06-.02-.13-.03-.2-.03-.42,0-.76.37-.72.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-c3",
    d: "M28.1,12.64c.07-.03.15-.04.23-.04.07,0,.14.01.2.03.09.03.17-.04.17-.13v-.9c0-.13.11-.22.23-.22,1.88.12,3.39,1.69,3.39,3.61,0,.07,0,.14,0,.2,0,.12-.1.21-.22.21h-.47c-.09,0-.15-.08-.13-.17.03-.09.04-.19.02-.3-.04-.33-.31-.59-.64-.63-.43-.05-.8.29-.8.72,0,.07.01.14.03.2.03.09-.04.17-.13.17h-.98c-.16,0-.3-.13-.3-.3v-.98c0-.09-.08-.15-.17-.13-.09.03-.19.04-.3.02-.33-.04-.59-.31-.63-.64,0-.03,0-.06,0-.09"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-c3",
    d: "M29.99,17.48c.14,0,.25.13.22.27-.13.66-.43,1.26-.86,1.74-.53.58-.9,1.29-1.04,2.06l-.02.13h-1.62v-1.28c0-.09.08-.15.17-.13.09.03.19.04.3.02.33-.04.59-.31.63-.64.05-.43-.29-.8-.72-.8-.07,0-.14.01-.2.03-.09.03-.17-.04-.17-.13v-1.28h1.28c.09,0,.15-.08.13-.17-.03-.09-.04-.19-.02-.3.04-.33.31-.59.64-.63.43-.05.8.29.8.72,0,.07-.01.14-.03.2-.02.09.04.17.13.17h.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-c3",
    d: "M24.01,19.52c-.51-.55-.85-1.26-.94-2.04h.68c.09,0,.15.08.13.17-.03.09-.04.19-.02.3.04.33.31.59.64.63.43.05.8-.29.8-.72,0-.07-.01-.14-.03-.2-.03-.09.04-.17.13-.17h1.28v1.28c0,.09.09.15.17.13.06-.02.13-.03.2-.03.43,0,.76.37.72.8-.04.33-.3.6-.63.64-.1.01-.2,0-.3-.02-.08-.03-.17.04-.17.13v1.28h-1.62l-.02-.12c-.09-.45-.24-.89-.47-1.29"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-c3",
    points: "26.38 22.38 28.28 22.38 28.28 23.13 25.04 23.13 25.04 22.38 25.52 22.38"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-c3",
    x1: 31.16,
    y1: 18.72,
    x2: 31.81,
    y2: 18.76
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-c3",
    x1: 30.59,
    y1: 20.19,
    x2: 31.09,
    y2: 20.59
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-c3",
    x1: 29.44,
    y1: 21.68,
    x2: 29.27,
    y2: 21.04
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-c3",
    x1: 24.63,
    y1: 12.95,
    x2: 24.52,
    y2: 12.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-c3",
    x1: 23.22,
    y1: 13.66,
    x2: 22.77,
    y2: 13.21
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-c3",
    x1: 21.86,
    y1: 14.96,
    x2: 22.51,
    y2: 15.06
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarteleraGac);
export default __webpack_public_path__ + "static/media/CarteleraGAC.7904ccea74f07fa9205bd4b880c4b9b2.svg";
export { ForwardRef as ReactComponent };